export default "__VITE_ASSET___Bz991nI__"